import { useState, useCallback, useEffect, RefObject } from 'react';
import { useLocation } from 'react-use';
interface IProps {
    element?: RefObject<HTMLElement>;
    stickyPosition?: number;
    page: string;
}
export default function useSticky(props: IProps) {
    const { stickyPosition = 50, page } = props;
    const location = useLocation();
    const [isSticky, setSticky] = useState(false);
    const [pStick, setpStick] = useState<number>(stickyPosition);

    const handleScroll = useCallback(
        (evt: any) => {
            setpStick(stickyPosition);

            const window = evt.currentTarget;
            if (window.scrollY > pStick) {
                setSticky(true);
            } else if (window.scrollY < pStick + 5) {
                setSticky(false);
            }
        },
        [isSticky, pStick, page]
    );
    
    useEffect(() => {
        setpStick(stickyPosition);
    }, [location]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [pStick, page]);

    return [isSticky];
}
